import PageHeader from '@/components/feature/PageHeader';
import { usePageMeta } from '@/hooks/usePageMeta';

const features = [
  {
    icon: 'ri-film-line',
    title: '海量影视资源',
    desc: '覆盖电影、电视剧等多种类型，从院线热映到经典佳作持续更新。',
  },
  {
    icon: 'ri-list-check-2',
    title: '清晰内容分类',
    desc: '按类型、地区、年份多维筛选，支持评分与更新时间排序。',
  },
  {
    icon: 'ri-newspaper-line',
    title: '实时影视资讯',
    desc: '独立资讯频道，聚合行业动态、热片口碑与幕后故事。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '贴心收藏体验',
    desc: '一键收藏喜爱的作品，收藏状态在本地浏览器中保持同步。',
  },
];

const contacts = [
  { icon: 'ri-mail-line', label: '内容合作邮箱', value: 'support@hongtaotv.demo' },
  { icon: 'ri-wechat-line', label: '微信公众号', value: '红桃影视' },
  { icon: 'ri-customer-service-2-line', label: '用户反馈', value: 'feedback@hongtaotv.demo' },
  { icon: 'ri-map-pin-line', label: '办公地址', value: '示例市影视产业园 A 座 18F（示范）' },
];

export default function About() {
  usePageMeta(
    '关于我们 - 红桃影视',
    '了解红桃影视的网站定位、内容特色与联系方式。红桃影视致力于为影视爱好者提供专业、易用的在线影视内容与资讯平台。',
  );

  return (
    <div className="pb-6">
      <PageHeader
        title="关于红桃影视"
        description="专业、易用的在线影视内容与资讯平台，为每一位影视爱好者提供丰富资源与及时资讯。"
        items={[{ label: '关于我们' }]}
      />

      <section className="px-4 md:px-6 lg:px-10 mt-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 rounded-lg bg-background-100 border border-background-300/60 p-6 md:p-8">
            <h2 className="text-xl font-bold text-foreground-950 font-heading">网站定位</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              红桃影视致力于构建一个专业、易用的在线电影电视剧观看与资讯获取平台，满足用户在线观看最新及经典影视作品，并获取详细剧集介绍和行业动态的需求。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们的目标用户涵盖影视剧迷、追剧党以及需要查询影视资讯的用户，注重内容丰富度和清晰的内容分类，力求让每一次访问都高效而愉快。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              需要说明的是，当前网站为产品演示版本，影视内容与资讯均为示范数据，播放功能为前端交互演示，不提供真实视频播放或下载服务。
            </p>
          </div>

          <div className="rounded-lg bg-primary-500/10 border border-primary-500/20 p-6 md:p-8">
            <h2 className="text-lg font-bold text-foreground-950 font-heading">品牌理念</h2>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
              “红桃”象征着热情与好内容。我们希望用鲜明的品牌色与清晰的信息结构，让找片、追剧、看资讯都变成一件轻松的事。
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4">
              <div className="rounded-lg bg-background-50/60 p-4">
                <p className="text-2xl font-display text-primary-400">{'>'}500</p>
                <p className="mt-1 text-xs text-foreground-600">示范影视条目</p>
              </div>
              <div className="rounded-lg bg-background-50/60 p-4">
                <p className="text-2xl font-display text-accent-400">每日</p>
                <p className="mt-1 text-xs text-foreground-600">资讯与更新</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 lg:px-10 mt-12">
        <h2 className="text-xl font-bold text-foreground-950 font-heading flex items-center gap-3 mb-6">
          <span className="w-1.5 h-7 rounded-full bg-primary-500" />
          平台特色
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((f) => (
            <div
              key={f.title}
              className="rounded-lg bg-background-100 border border-background-300/60 p-5"
            >
              <span className="w-12 h-12 rounded-lg bg-accent-500/15 text-accent-400 flex items-center justify-center text-2xl">
                <i className={f.icon} />
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="px-4 md:px-6 lg:px-10 mt-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="rounded-lg bg-background-100 border border-background-300/60 p-6 md:p-8">
            <h2 className="text-xl font-bold text-foreground-950 font-heading">联系方式</h2>
            <ul className="mt-5 space-y-4">
              {contacts.map((c) => (
                <li key={c.label} className="flex items-start gap-3">
                  <span className="w-10 h-10 rounded-lg bg-background-200 flex items-center justify-center text-lg text-primary-400 shrink-0">
                    <i className={c.icon} />
                  </span>
                  <span>
                    <span className="block text-xs text-foreground-500">{c.label}</span>
                    <span className="block mt-0.5 text-sm text-foreground-800">{c.value}</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg bg-background-100 border border-background-300/60 p-6 md:p-8">
            <h2 className="text-xl font-bold text-foreground-950 font-heading">版权声明与使用须知</h2>
            <ul className="mt-5 space-y-3 text-sm text-foreground-600 leading-relaxed">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-primary-400 mt-0.5" />
                本站为产品演示站点，所有影视与资讯内容均为示范数据，不涉及真实版权作品。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-primary-400 mt-0.5" />
                站内不提供真实视频播放与下载功能，播放相关交互仅为前端界面演示。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-primary-400 mt-0.5" />
                收藏功能基于浏览器本地存储实现，不会上传任何个人数据。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-primary-400 mt-0.5" />
                如需转载或合作，请通过上方邮箱与我们联系。
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}